import moment from 'moment-timezone'
import { apiProcess } from 'components/api/api'

export const prepStartAndEndTimeForBackend = (inputTime) => {

  let startTime = 'start_time' in inputTime ? inputTime.start_time : null
  let endTime = 'end_time' in inputTime ? inputTime.end_time : null
  let startDate = 'start_date' in inputTime ? inputTime.start_date : null
  let endDate = 'end_date' in inputTime ? inputTime.end_date : null
  let timezone = 'timezone' in inputTime ? inputTime.timezone : null

  if (!timezone) {
    return false
  } //if we don't have a timezone then this is useless.
  if (startDate == null && endDate == null) {
    return false
  }

  let startDateTime = null
  let endDateTime = null

  if (startTime == null || endTime == null) {
    //check if it's the same day
    if (
      moment(startDate)
        .tz(timezone)
        .isSame(moment(endDate).tz(timezone), 'day')
    ) {
      // alert('one was null, same day')
      startDateTime = moment(startDate)
        .clone()
        .tz(timezone)
        .startOf('day')
      endDateTime = moment(endDate)
        .clone()
        .tz(timezone)
        .startOf('day')
        .add(1, 'hours')
    } else {
      //alert('one was null, different days')
      startDateTime = moment(startDate)
        .clone()
        .tz(timezone)
        .startOf('day')
      endDateTime = moment(endDate)
        .clone()
        .tz(timezone)
        .startOf('day')
    }
  } else {
    //alert('user put in times')
    startDateTime = moment(startDate)
      .clone()
      .tz(timezone)
      .set('hours', Number(startTime))
    endDateTime = moment(endDate)
      .clone()
      .tz(timezone)
      .set('hours', Number(endTime))
  }

  return {
    start_at: startDateTime.utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
    end_at: endDateTime.utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
  }
}

export const createReservationTimeStamp = (momentObject, hour, timezone) => {
  return moment(momentObject)
    .tz(timezone)
    .set('hour', hour)
    .utc()
    .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
}

export const notifyVouchedProgressToHobNob = (resID, stepType) => {
  // notify vouched progress to hobnob when rider books/click upload license button
  let apiURL = 'riders/data'
  let apiData =  {
    name: stepType == 'payment' ?
      'reservation.vouched.workflow.required' :
      'reservation.vouched.workflow.started',
    category: 'identity',
    value: resID
  }

  apiProcess(apiURL, apiData, 'rider-vouched-progress-data', 'Payment page vouched progress POST')
    .then(
      function(responseData) {
        console.log(`vouched progress post succeed for ${stepType} page`, responseData)
      }
    )
    .catch(
      function(errorResponse) {
        console.log('vouched progress post failed', errorResponse)
      }
    )
}
